import React from 'react';
import { Helmet } from 'react-helmet';

function DeleteUser() {
    return (
        <>
            <Helmet>
                <title>Center Account Deletion Instructions(Khat APP) | khatApp</title>
            </Helmet>
            <div className="account-pages mt-5 mb-5">
                <div className="container">
                    <div className="card">
                        <div className="card-body text-center">
                            <br />
                            <h1>Center Account Deletion Instructions (Khat APP)</h1>
                            <hr />
                            <br />
                            <h6>
                                If you want to delete your activities for Khat APP, you can
                                remove them by following these steps:
                            </h6>
                            <br />
                            <hr />
                            <h6>
                                1. Launch the app: Open the app on your device and tap the Menu
                                icon located at the top left corner.
                            </h6>
                            <br />
                            <img
                                src="/assets/imges/d1.jpg"
                                alt="Step 1"
                                className='image-fluid'
                                style={{ width: '230px ', borderRadius: '8px' }}
                            />
                            <br />
                            <hr />
                            <br />
                            <h6>
                                2. Access Setting: Click On Setting  Icon.
                            </h6>
                            <br />
                            <img
                                src="/assets/imges/d2.jpg"
                                alt="Step 2"
                                className='image-fluid'
                                style={{ width: '230px ', borderRadius: '8px' }}
                            />
                            <br />
                            <hr />
                            <br />
                            <h6>
                                3. Delete Account: After click on delete Profile option show popup and ask to "Are you sure you want to delete your account?" And click on "OK" button.
                            </h6>
                            <br />
                            <img
                                src="/assets/imges/d3.jpg"
                                alt="Step 3"
                                className='image-fluid'
                                style={{ width: '230px ', borderRadius: '8px' }}
                            />
                            <hr />
                            <br />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DeleteUser;
